
export interface IOrderAddon {
  addonId?: number | null;
  title?: string | null;
  price?: number | null;
  quantity?: number | null;
  costs?: number | null;
  single?: boolean | null;
}

export class OrderAddon implements IOrderAddon {
  constructor(
    public addonId?: number | null,
    public title?: string | null,
    public price?: number | null,
    public quantity?: number | null,
    public costs?: number | null,
    public single?: boolean | null
  ) { }
}
